import { Component } from '@angular/core';

import { SnChatUser } from '@lib/communication/twiliochat';
import { SnListBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.scss'],
})
export class SnMemberListComponent extends SnListBaseComponent<SnChatUser> {
  public isExternal: boolean;

  constructor() {
    super();
  }

  public trackBy(index: number, item: SnChatUser): any {
    return item.sid;
  }

  public filterOnlineUsers(chatUsers: SnChatUser[]): SnChatUser[] {
    return chatUsers.filter((chatUser) => chatUser.isOnline);
  }
}
